import React, { RefAttributes } from "react";
import { useAppSelector } from "../store/hooks";
import { NavLinkProps, NavLink } from "react-router-dom";

/**
 * All the components in here become disabled if there are ongoing requests.
 */

export function Anchor({ children, ...props }: { children?: React.ReactNode; } & NavLinkProps & RefAttributes<HTMLAnchorElement>)
{
   const requestsOngoing = useAppSelector(state => state.apiRequests.ongoingRequestCount);
   delete props.key;

   return requestsOngoing
       ? <u>{children}</u>
       : <NavLink {...props}>{children}</NavLink>;
}

type elementNames = 'button' | 'input' | 'textarea' | 'select';
function createCustomElement<T extends elementNames>(tag: T)
{
    return function({ ...props }: {children?: React.ReactNode} & React.ComponentPropsWithRef<T>)
    {
        const requestsOngoing = useAppSelector(state => state.apiRequests.ongoingRequestCount);
        if (requestsOngoing)
        {
            props.disabled = true;
        }

        if (tag === 'button')
        {
            //What do you know. If a button doesn't have type "button", it submits the containing form.
            (props as any).type ??= 'button';
        }

        delete props.key;

        return React.createElement(tag, props);
    };
}

export const Button = createCustomElement('button');
export const Input = createCustomElement('input');
export const TextArea = createCustomElement('textarea');
export const Select = createCustomElement('select');